export default __webpack_public_path__ + "static/media/Green0001.080cb428.png";